import { queryOptions, useQuery } from "@tanstack/react-query";
import { api, exigir } from "../api/cliente";

export const consultaEu = queryOptions({
  queryKey: ["eu"],
  queryFn: () => exigir(api.GET("/api/eu")),
  staleTime: 5 * 60_000,
});

export function useEu() {
  return useQuery(consultaEu);
}
